import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { Input } from "../components/ui/input";
import { api } from "../lib/api";
import { useI18n } from "../lib/i18n";
import { PageHeader } from "../components/Card";
import { DataTable } from "../components/DataTable";
import { Severity, StatusPill } from "../components/Severity";

const STATUSES = ["", "open", "in_progress", "evidence_submitted", "pending_approval", "approved", "rejected", "closed"];

export default function Tasks() {
  const { t, tv } = useI18n();
  const nav = useNavigate();
  const [status, setStatus] = useState("");
  const [q, setQ] = useState("");
  const [rows, setRows] = useState([]);
  useEffect(() => {
    const h = setTimeout(() => api.get("/tasks", { params: { status, q } }).then((r) => setRows(r.data)), 250);
    return () => clearTimeout(h);
  }, [status, q]);

  const cols = [
    { key: "id", label: "ID", render: (r) => <span className="font-mono text-xs text-sky-700">{r.id}</span> },
    { key: "title", label: t("title"), render: (r) => <span className="font-medium text-slate-900">{r.title}</span> },
    { key: "use_case_id", label: "UC", render: (r) => <span className="font-mono text-xs">{r.use_case_id}</span> },
    { key: "assignee_name", label: t("assignee") },
    { key: "priority", label: t("priority"), render: (r) => <Severity value={r.priority} /> },
    { key: "status", label: t("status"), render: (r) => <StatusPill value={r.status} /> },
    { key: "due_date", label: t("dueDate"), render: (r) => <span className="font-mono text-xs">{r.due_date || "—"}</span> },
  ];

  return (
    <div>
      <PageHeader title={t("nav_tasks")} sub={`${t("total")}: ${rows.length}`} />
      <div className="mb-4 flex gap-2 overflow-x-auto pb-1" role="tablist">
        {STATUSES.map((s) => (
          <button key={s || "all"} data-testid={`task-status-tab-${s || "all"}`} onClick={() => setStatus(s)}
            className={`whitespace-nowrap rounded-xl px-3 py-1.5 text-xs font-semibold transition-colors ${status === s ? "bg-slate-900 text-white" : "bg-white text-slate-600 border border-slate-200 hover:bg-slate-100"}`}>
            {s ? tv(s) : t("all")}
          </button>
        ))}
      </div>
      <div className="relative mb-4 max-w-md">
        <Search className="absolute start-3 top-3 h-4 w-4 text-slate-400" />
        <Input data-testid="task-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder={t("search")} className="h-10 rounded-xl ps-9" />
      </div>
      <DataTable cols={cols} rows={rows} testId="tasks-table" onRowClick={(r) => nav(`/tasks/${r.id}`)} />
    </div>
  );
}
